import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { filter, map, of, take } from 'rxjs';
import { inject } from '@angular/core';
import { BrandingService } from '@kempower-nx-workspace/receipt-lookup-app-core';
import { NOT_FOUND_PATH } from '@kempower-nx-workspace/receipt-lookup-environment';

// Guard to check if the branding (from ConfigService customerId) is valid
export const pageNotFoundGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    const brandingService = inject(BrandingService);

    // Check if we're already on the redirect target to prevent infinite loops, redirect to provided target if not
    const redirectTo = route.data['redirectTo'] as string | undefined;
    const redirectTargetUrl: UrlTree = router.createUrlTree(['/', redirectTo || NOT_FOUND_PATH]);

    if (
        router.isActive(redirectTargetUrl, {
            paths: 'exact',
            queryParams: 'exact',
            matrixParams: 'exact',
            fragment: 'exact',
        })
    ) {
        // Already on the error page, allow navigation
        return of(true);
    }

    return brandingService.ensureBrandingLoaded$().pipe(
        filter((state) => !state.loading),
        take(1),
        map((state) => {
            const invalid = state.error || !state.data?.branding?.receiptLookup?.enabled;
            return invalid ? redirectTargetUrl : true;
        })
    );
};
